var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "navbar fixed-top navbar-expand-lg navbar-dark",
      class: [_vm.themeClass, { "unverified-nav": !_vm.verifiedAccount }],
      attrs: { id: "nav-central" },
    },
    [
      _c("div", { staticClass: "navbar-wrap" }, [
        _c("a", { staticClass: "mr-3", attrs: { href: _vm.navBarLink } }, [
          _vm.autobahn
            ? _c("div", { staticClass: "brand-logo-box" }, [
                _c("img", { attrs: { src: _vm.logo, alt: "", height: "30" } }),
              ])
            : _c("div", { staticClass: "brand-logo" }, [
                _c("img", { attrs: { src: _vm.logo, height: "60" } }),
              ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "navbar-toggler",
            attrs: {
              type: "button",
              "data-toggle": "collapse",
              "data-target": "#navbarCollapsed",
              "aria-controls": "navbarCollapsed",
              "aria-expanded": "false",
              "aria-label": "Toggle navigation",
            },
            on: { click: _vm.handleToggleNavbar },
          },
          [_c("i", { staticClass: "fa", class: _vm.menuIcon })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "navbar-collapse collapse ml-auto",
          attrs: { id: "navbarCollapsed" },
        },
        [_c("ul", { staticClass: "navbar-nav" }, [_vm._t("nav-items")], 2)]
      ),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("noscript", [
      _c("div", { staticClass: "javascript-required mt-5" }, [
        _c("img", {
          staticClass: "mb-3",
          attrs: { src: "/assets/images/cogs.svg" },
        }),
        _vm._v(" "),
        _c("h3", [_vm._v("We have a small problem")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Javascript appears to be disabled, please enable javascript to use Autobahn"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }